export const URLS = {
  // Live
  // baseApi: 'https://api.bad-kursmanager.de/api/student/',

  // Staging
  // baseApi: 'https://api.akademio-digital.de/api/student/',

  // Local
  // baseApi: 'http://192.168.31.248:3000/api/student/',

  // MAB
  baseApi: "https://api.mab.akademio-digital.de/api/student/",
};
